"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sum = sum;
function sum(arr, getter) {
    return arr.reduce(function (acc, item, index) {
        if (typeof item === 'number') {
            var value_1 = getter ? getter(item, index) : item;
            return acc + value_1;
        }
        if (!getter) {
            return 0;
        }
        var value = getter(item, index);
        return acc + value;
    }, 0);
}
